import { cn } from '@sohanemon/utils';
import { m } from '@sohanscript/i18n';
import { TextRotate } from '@sohanscript/ui/rotate-text';
import { SLogo } from '@sohanscript/ui/s-logo';
import { Link } from '@/components/link';
import { getBrand } from '@/lib/utils/app-env';

interface BrandProps {
	className?: string;
	full?: boolean;
	noAnim?: boolean;
	mini?: boolean;
}

const ALL_WORDS = [
	'Script',
	'js',
	'emon',
	'codes',
	'works',
	'writes',
	'ships',
	'builds',
	'notes',
];

export function Brand({ className, noAnim, full, mini }: BrandProps) {
	const [brandFirst, brandLast] = getBrand().words;
	const texts = [brandLast, ...ALL_WORDS.filter((w) => w !== brandLast)];

	return (
		<Link
			to="/"
			hash="top"
			aria-label={m.brand_go_home()}
			className={cn(
				'group/brand inline-flex origin-left items-end text-center font-black font-sans text-muted/60 leading-4 max-sm:scale-75',
				mini && 'items-center leading-none',
				className,
			)}
		>
			<SLogo className={cn('h-11', mini && 'h-5')} />

			{!mini && (
				<h2
					className={cn(
						'h-5 w-fit text-primary',
						'font-matrix text-sm',
						'flex items-center',
						!full &&
							'scale-x-0 align-bottom font-bold leading-normal opacity-0 transition-all duration-400 ease-out group-hover/brand:translate-x-0 group-hover/brand:scale-x-100 group-hover/brand:opacity-100',
						!full &&
							'origin-top-left -translate-x-7 rtl:origin-top-right rtl:translate-x-7',
					)}
				>
					{brandFirst}
					{noAnim ? (
						brandLast
					) : (
						<TextRotate className="brightness-70" texts={texts} />
					)}
				</h2>
			)}
		</Link>
	);
}
